export default __webpack_public_path__ + "static/media/white-video-play-icon.b9c1b305.svg";